import React from 'react';
import { Button } from './ui/button';
import { X, Plus, ListPlus, Repeat } from 'lucide-react';

const AddPartToQueueDialog = ({ open, part, onConfirm, onClose }) => {
  if (!open || !part) return null;

  const handleConfirm = (mode) => {
    onConfirm(part.id, mode);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-dark-card border border-sunset-orange/30 rounded-2xl shadow-2xl max-w-md w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-700/50">
          <h2 className="text-xl font-bold text-white">
            Ajouter à la file
          </h2>
          <button
            onClick={onClose}
            className="text-purple-300 hover:text-white transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <p className="text-purple-200">
            Ajouter tous les titres de <span className="font-semibold text-white">"{part.name}"</span> à la file d'attente :
          </p>

          {/* Options */}
          <div className="space-y-3">
            {/* Append to end */}
            <button
              onClick={() => handleConfirm('append')}
              className="w-full flex items-start gap-4 p-4 bg-dark-input/50 hover:bg-dark-input border border-sunset-orange/20 hover:border-sunset-orange/40 rounded-lg transition-all group"
            >
              <div className="p-2 bg-purple-500/10 group-hover:bg-purple-500/20 rounded-lg transition-colors">
                <Plus className="w-5 h-5 text-purple-400" />
              </div>
              <div className="flex-1 text-left">
                <h3 className="font-semibold text-white mb-1">
                  Ajouter à la fin
                </h3>
                <p className="text-sm text-sunset-orange/60">
                  Les titres seront ajoutés après la file actuelle
                </p>
              </div>
            </button>

            {/* Play next */}
            <button
              onClick={() => handleConfirm('next')}
              className="w-full flex items-start gap-4 p-4 bg-dark-input/50 hover:bg-dark-input border border-sunset-orange/20 hover:border-sunset-orange/40 rounded-lg transition-all group"
            >
              <div className="p-2 bg-blue-500/10 group-hover:bg-blue-500/20 rounded-lg transition-colors">
                <ListPlus className="w-5 h-5 text-blue-400" />
              </div>
              <div className="flex-1 text-left">
                <h3 className="font-semibold text-white mb-1">
                  Jouer ensuite
                </h3>
                <p className="text-sm text-sunset-orange/60">
                  Les titres seront ajoutés en priorité au début de la file
                </p>
              </div>
            </button>

            {/* Replace queue */}
            <button
              onClick={() => handleConfirm('replace')}
              className="w-full flex items-start gap-4 p-4 bg-dark-input/50 hover:bg-dark-input border border-red-500/20 hover:border-red-500/40 rounded-lg transition-all group"
            >
              <div className="p-2 bg-red-500/10 group-hover:bg-red-500/20 rounded-lg transition-colors">
                <Repeat className="w-5 h-5 text-red-400" />
              </div>
              <div className="flex-1 text-left">
                <h3 className="font-semibold text-white mb-1">
                  Remplacer la file
                </h3>
                <p className="text-sm text-sunset-orange/60">
                  Vider la file actuelle et la remplacer par ces titres
                </p>
              </div>
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-slate-700/50">
          <Button
            onClick={onClose}
            variant="outline"
            className="w-full border-sunset-orange/30 text-sunset-orange hover:bg-purple-500/10"
          >
            Annuler
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddPartToQueueDialog;
